import { emit } from '../events/notifier';
import { snakeToCamel } from '../utils/utils';
export function addEvents(eventsTarget, events, methods) {
  const methodsWithEvents = {
    ...methods
  };
  Object.keys(events).forEach(function (eventKey) {
    const methodName = snakeToCamel(eventKey.toLowerCase());
    if (typeof methods[methodName] === 'object' && methods[methodName] !== null && typeof events[eventKey] === 'object' && events[eventKey] !== null) {
      methodsWithEvents[methodName] = addEvents(eventsTarget, events[eventKey], methods[methodName]);
      return;
    } else if (typeof methods[methodName] !== 'function') {
      return;
    }

    // define new method with event generation
    methodsWithEvents[methodName] = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      // emit before event and call native method
      //const event = emit(eventsTarget, events[eventKey], {arguments: arguments});
      const promise = methods[methodName].apply(methods, args);
      const params = {
        arguments: args
      };
      let event;
      if (Array.isArray(promise)) {
        params.promises = promise;
        event = emit(eventsTarget, events[eventKey], params);
        promise.forEach(function (promise, index) {
          promise.then(function (data) {
            event.resolveAt(index, data);
          }, function (reason) {
            event.rejectAt(index, reason);
          });
        });
        return promise;
      }
      event = emit(eventsTarget, events[eventKey], params);
      const wrapped = promise.then(function (data) {
        event.resolve(data);
        return data;
      }, function (reason) {
        event.reject(reason);
        return Promise.reject(reason);
      });
      return wrapped;
    };
  });
  return methodsWithEvents;
}